import { render, staticRenderFns } from "./FreightRate copy.vue?vue&type=template&id=51c77006&scoped=true"
import script from "./FreightRate copy.vue?vue&type=script&lang=js"
export * from "./FreightRate copy.vue?vue&type=script&lang=js"
import style0 from "./FreightRate copy.vue?vue&type=style&index=0&id=51c77006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c77006",
  null
  
)

export default component.exports